(() => {
  if (customElements.get('bumpino-brand-story')) return;
  class BumpinoBrandStory extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.tabs = Array.from(this.querySelectorAll('[data-story-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-story-panel]'));
      this.tablist = this.querySelector('[data-story-tabs]');
      if (!this.tabs.length || this.tabs.length !== this.panels.length || !this.tablist) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tablist.setAttribute('role', 'tablist');
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.addEventListener('click', () => this.select(index), options);
        tab.addEventListener('keydown', event => this.onKey(event, index), options);
        this.panels[index].setAttribute('role', 'tabpanel');
        this.panels[index].tabIndex = 0;
      });
      this.addEventListener('shopify:block:select', event => {
        const index = this.tabs.findIndex(tab => tab.dataset.storyBlock === event.detail?.blockId);
        if (index !== -1) this.select(index);
      }, options);
      this.select(Math.min(this.activeIndex || 0, this.tabs.length - 1));
      this.dataset.ready = '';
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
    select(index, focus = false) {
      if (!this.tabs[index]) return;
      this.activeIndex = index;
      this.dataset.activeIndex = String(index);
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        this.panels[i].hidden = i !== index;
      });
      if (focus) this.tabs[index].focus({ preventScroll: true });
    }
    onKey(event, index) {
      let target;
      const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
      if (event.key === 'ArrowRight') target = (index + direction + this.tabs.length) % this.tabs.length;
      if (event.key === 'ArrowLeft') target = (index - direction + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') target = 0;
      if (event.key === 'End') target = this.tabs.length - 1;
      if (target === undefined) return;
      event.preventDefault();
      this.select(target, true);
    }
  }
  customElements.define('bumpino-brand-story', BumpinoBrandStory);
})();
